/**
 * S-123 (06.10.2026, właściciel ze zrzutem „Przewoźnik nie anulował etykiety — Ta operacja nie jest wspierana
 * przez przewoźnika”: „dobrze, jakby w tym powiadomieniu było info, co to za przewoźnik”).
 *
 * Wspólne okna anulowania etykiety — Pulpit („Wiszące etykiety”) i etykiety w zamówieniu:
 * - przewoźnik z API (`przewoznik`): dla WzA metoda dostawy zamówienia („Allegro Kurier DPD (AD) (Wysyłam z Allegro)”),
 *   dla ShipX „InPost (ShipX)”;
 * - paczki obsługiwane przez Allegro (`carrierId: ALLEGRO` — Allegro One, Allegro Delivery „AD”, Allegro International):
 *   Allegro nie pozwala ich anulować (dokumentacja „Wysyłam z Allegro”, „Jak anulować paczkę”: „Nie możesz anulować
 *   paczek ze wskazaną metodą dostawy z carrierId: ALLEGRO”) — od razu wybór „tylko w SellBase” albo „zostaw”.
 */
import type { SbConfirmOptions } from './sb-dialogs.ts';

type Potwierdz = (title: string, message: string, opts?: SbConfirmOptions) => Promise<boolean>;
interface OdpAnulowania { cancel_code?: string; przewoznik?: string }

/** `cancel_code` z `/withdraw-label`, gdy SellBase nie pytał Allegro (paczka obsługiwana przez Allegro). */
export const KOD_BEZ_ANULOWANIA = 'ALLEGRO_BEZ_ANULOWANIA';

const OPCJE_ODMOWY: SbConfirmOptions = {
  tone: 'warning', okLabel: 'Oznacz jako anulowaną tylko w SellBase', cancelLabel: 'Zostaw aktywną',
};

function _przewoznik(p?: string | null): string {
  const t = String(p || '').trim();
  return t ? 'Przewoźnik: ' + t + '. ' : '';
}

/** Treść pytania „Anulować etykietę?” — z przewoźnikiem, gdy go znamy. */
export function pytanieAnulowania(przewoznik?: string): string {
  const p = String(przewoznik || '').trim();
  return 'SellBase poprosi przewoźnika' + (p ? ' (' + p + ')' : '') + ' o anulowanie. Etykieta zniknie dopiero po jego potwierdzeniu.';
}

/** Paczka obsługiwana przez Allegro: anulowania nie ma — true = „Oznacz jako anulowaną tylko w SellBase”. */
export function oknoBezAnulowania(potwierdz: Potwierdz, przewoznik?: string | null): Promise<boolean> {
  return potwierdz('Allegro nie pozwala anulować tej etykiety',
    _przewoznik(przewoznik) + 'Paczek obsługiwanych przez Allegro (Allegro One, Allegro Delivery „AD”, Allegro International) '
      + 'nie da się anulować — to zasada Allegro dla „Wysyłam z Allegro”. Etykieta zostaje aktywna w Allegro.',
    Object.assign({}, OPCJE_ODMOWY, { note: 'Jeśli paczka nie zostanie nadana, oznacz ją jako anulowaną tylko w SellBase.' }));
}

/** Odmowa przewoźnika (`cancel_blocked` z `/withdraw-label` albo zapisana wcześniej) — true = „tylko w SellBase”.
 *  `powod` = czytelny powód (Pulpit przepuszcza go przez `czytelnyPowod`). */
export function oknoOdmowyAnulowania(potwierdz: Potwierdz, odp: OdpAnulowania | null | undefined, powod: string): Promise<boolean> {
  if (odp && odp.cancel_code === KOD_BEZ_ANULOWANIA) return oknoBezAnulowania(potwierdz, odp.przewoznik);
  return potwierdz('Przewoźnik nie anulował etykiety',
    _przewoznik(odp && odp.przewoznik) + 'Powód: ' + (String(powod || '').trim() || 'brak odpowiedzi').replace(/\.+$/, '')
      + '. Etykieta jest nadal aktywna u przewoźnika.',
    Object.assign({}, OPCJE_ODMOWY, { note: 'Jeśli paczka nie wyjedzie, anuluj ją w panelu przewoźnika.' }));
}
